import { motion } from 'framer-motion';
import { useState } from 'react';
import { Button } from '@material-ui/core';
import { Header, Container } from '../../../styles/shared/styles';
import { SecaoBotoes, SecaoPagina } from './styles';
import SubscriptionWithoutFinishedLead from './subscriptionWithoutFinishedLeadReport';
import CanceledSubscriptions from './canceledSubscriptions';
import SubscriptionsReport from '.'
import PaymentReport from './paymentReport';


const SubscriptionMenu = () => {
  const [paginaAtual, setPaginaAtual] = useState('')

  const renderPagina = () => {
    switch (paginaAtual) {
      case 'relatorio-subscription-without-finished-lead': return <SubscriptionWithoutFinishedLead />
      case 'relatorio-assinaturas': return <SubscriptionsReport />
      case 'relatorio-pagamentos': return <PaymentReport />
      // case 'relatorio-canceled-subscriptions': return <CanceledSubscriptions />
      default: return <i>Escolha uma opção para abrir.</i>
    }
  }

  return (<>
    <motion.div initial={{ opacity: 0, x: -100 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -100 }}>
      <Container>
        <Header>
          {!paginaAtual && <h2>Menu de Assinaturas</h2>}
        </Header>
        <div>
          <SecaoBotoes>
            <Button variant="contained" onClick={() => setPaginaAtual('relatorio-assinaturas')}>
              Relatório de <br/>Assinaturas
            </Button>
            <Button variant="contained" onClick={() => setPaginaAtual('relatorio-pagamentos')}>
              Relatório de <br/>Pagamentos
            </Button>
            <Button variant="contained" onClick={() => setPaginaAtual('relatorio-subscription-without-finished-lead')}>
              Relatório de Clientes<br/>com Leads não finalizados
            </Button>
            {/*
            <Button variant="contained" onClick={() => setPaginaAtual('relatorio-canceled-subscriptions')}>
              Relatório de Clientes<br/>com Assinatura cancelada
            </Button>
            */}
          </SecaoBotoes>
          <SecaoPagina>
            {renderPagina()}
          </SecaoPagina>
        </div>
      </Container>
    </motion.div>
  </>
  )
}

export default SubscriptionMenu;